import type { AjaxResponse } from 'rxjs';
import { get } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import { getMeta } from '@helpcenter/meta';
import * as qs from 'query-string';
import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import FeatureGates from '@atlaskit/feature-gate-js-client';
// eslint-disable-next-line no-restricted-imports
import { ConfluencePageAri, JiraProjectAri } from '@atlassian/ari';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { APOLLO_STARGATE_CONTEXT_ROOT } from '../constants';

interface FetchCrossSiteArticleParams {
    articleId: string;
    projectId: number | undefined;
    crossSiteTenantId: string;
}

export interface FetchCrossSiteArticleResponse {
    pageAri: string;
    title: string;
    space: {
        id: string;
        key: string;
    };
    projects: [
        {
            projectId: string;
            projectAri: string;
            portalId: string;
        },
    ];
    hostname: string;
}

interface FetchCrossSiteArticleAjaxResponse extends AjaxResponse {
    response: FetchCrossSiteArticleResponse;
}

export const fetchCrossSiteArticles = ({
    articleId,
    projectId,
    crossSiteTenantId,
}: FetchCrossSiteArticleParams): Observable<FetchCrossSiteArticleResponse> => {
    const cloudId = getMeta('tenant-id') || '';
    const activationId = getMeta('activation-id') as string;
    const pageAri = ConfluencePageAri.create({ siteId: crossSiteTenantId, pageId: articleId }).toString();
    const projectAri =
        projectId && JiraProjectAri.create({ projectId: projectId.toString(), siteId: cloudId }).toString();

    const queryString = qs.stringify({
        pageAri,
        projectAri,
    });

    const queryStringV2 = qs.stringify({
        projectAri,
        articleAri: pageAri,
    });

    const uriV1 = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/help/knowledge-base/page-metadata?${queryString}`;
    const uriV2 = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/article-metadata?${queryStringV2}`;

    const uri = FeatureGates.checkGate('fe-calls-new-apis-for-service-sprawl-m4') ? uriV2 : uriV1;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(uri, { 'Content-Type': 'application/json' })
        .map(({ response }: FetchCrossSiteArticleAjaxResponse) => response)
        .catch((e: AjaxError) => {
            trackError('categories.fetch.all.failed', {}, e);
            return Observable.throw(e);
        });
};
